import * as React from 'react';

import { FormPrioritySelect } from '#components/FormPrioritySelect.tsx';
import { useFilters } from './FiltersContext.tsx';

export function FormPriority(props: { defaultValue?: 'all' | 'required' | 'optional' }) {
  const [value, setValue] = React.useState(props.defaultValue ?? 'all');

  const filters = useFilters();

  return (
    <FormPrioritySelect
      size="medium"
      value={value}
      onChange={(priority) => {
        setValue(priority);
        filters.onChange({ formsPriority: priority === 'all' ? undefined : priority });
      }}
      /**
       * An `aria-label` attribute can't be used because the way mui renders a
       * select text field, it applies an `aria-labelledby` attribute which
       * takes precedence over `aria-label`.
       */
      slotProps={{
        select: {
          SelectDisplayProps: {
            // @ts-expect-error - TS complains but it works just fine
            'data-testid': 'global-form-priority',
          },
        },
      }}
    />
  );
}
